import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { BiTmplDetail_18_1 } from '@/views/bi-tmpl/src/components/bi-tmpl-detail/bi-tmpl-detail-18/components/index';

export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-21-1-2',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BiTmplDetail_18_1), {
    style: {"margin-top":"20px"},
    showTitle: false,
    showSecordTitle: false,
    childKey: "21_1_2"
  }))
}
}

})